import * as React from "react";
import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../../../../constants";
import { Scoreboard } from "../../Scoreboard";
import { renderTeamsScore } from "../RenderMethods";
export const renderScore = (score1, score2, sportId, props) => Scoreboards[eBranches[sportId]]
    ? React.createElement(Scoreboard, Object.assign({}, props))
    : renderTeamsScore(score1, score2);
//# sourceMappingURL=renderScore.js.map